import { handleUrl, myHeadersWithToken } from '../global';
import { DetailProps, RegisterPasswordData } from './types';

export const registerPassword = (
  token: string,
  data: RegisterPasswordData
): Promise<DetailProps> => {
  const myHeaders = myHeadersWithToken();
  myHeaders.set('Authorization', `Bearer ${token}`);
  myHeaders.set('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(data),
  };
  const BaseUrl = handleUrl();
  return fetch(`${BaseUrl}/api/V1/companies/first-password`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const sendTokenPassword = (email: string): Promise<DetailProps> => {
  const myHeaders = myHeadersWithToken();

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
  };
  const BaseUrl = handleUrl();
  return fetch(
    `${BaseUrl}/api/V1/companies/first-password?email=${email}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};
